<template>
  <div>
    <div style="padding:10px 0px">
      <el-input
        style="width:40%"
        v-model="parmas.searchText"
        :placeholder="this.$t('common.searchValue')"
        @keyup.enter.native="loadDeviceEmployeList"
      >
        <el-button
          slot="append"
          @click.stop="loadDeviceEmployeList"
          icon="el-icon-search"
          type="primary"
        ></el-button>
      </el-input>
    </div>

    <div style="width:100%">
      <zk-table
        ref="table"
        stripe
        border
        :data="tableData"
        :columns="columnData"
      ></zk-table>

      <div style="margin-top:15px">
        <el-pagination
          background
          @size-change="changePageSize"
          @current-change="changePage"
          :current-page="pager.curPage"
          :page-size="pager.pageSize"
          layout="total, prev, pager, next"
          :total="pager.total"
        ></el-pagination>
      </div>
    </div>

    <!--<DeviceByEmploye></DeviceByEmploye>-->

    <el-dialog
      :title="this.$t('deviceEmp.deviceBindEmp')"
      :visible.sync="dialogVisible"
      width="50%"
      :before-close="handleClose"
    >
      <el-row style="max-height:360px">
        <el-col :span="8">
          <p>{{ $t('deviceEmp.orgTree') }}</p>
          <el-tree
            :props="props"
            @current-change="handleCheckChange"
            :data="orgData"
            node-key="id"
            :highlight-current="true"
            default-expand-all
            ref="org"
          ></el-tree>
        </el-col>
        <el-col :span="16">
          <p>{{ $t('deviceEmp.empList') }}</p>
          <el-table
            :data="employeeData"
            highlight-current-row
            ref="employeeTable"
            style="width: 100%;"
          >
            <el-table-column type="selection"></el-table-column>
            <el-table-column
              :label="this.$t('employee.employeeNo')"
              prop="employeeNo"
            ></el-table-column>
            <el-table-column
              :label="this.$t('employee.formattedName')"
              prop="formattedName"
            ></el-table-column>
          </el-table>
          <el-pagination
            @size-change="pageSizeChange(arguments[0], loadDeviceEmployeList)"
            @current-change="curPageChange(arguments[0], loadDeviceEmployeList)"
            :current-page="pagination.curPage"
            :page-size="pagination.pageSize"
            layout="total, prev, pager, next"
            :total="pagination.total"
          ></el-pagination>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">
          {{ $t('common.cancel') }}
        </el-button>
        <el-button @click="submitEmployeeBindDevice">
          {{ $t('common.confirm') }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getDeviceEmployeList,
  setEmployeeUnBindDevices,
  setEmployeeBindDevices
} from '@/services/deviceApi'
import { getUnbindDeviceEmployeList } from '@/services/employeeApi'
import { getOrgStructure } from '@/services/enterpriseApi'
import { emailFormat } from '../../../../cdpBase/utils/index'

export default {
  data() {
    return {
      tableData: [],
      columnData: [
        {
          label: this.$t('employee.employeeNo'),
          prop: 'employeeNo'
        },
        {
          label: this.$t('employee.formattedName'),
          prop: 'formattedName'
        },
        {
          label: this.$t('employee.gender'),
          prop: 'gender',
          render(h, params) {
            if (params.row.gender) {
              return h('zk-dictionary-value', {
                props: {
                  value: params.row.gender,
                  type: 'sex'
                }
              })
            } else {
              return h('span', {}, 'N/A')
            }
          }
        },
        {
          label: this.$t('employee.email'),
          prop: 'email',
          render(h, params) {
            if (params.row.email) {
              return h('span', emailFormat(params.row.email))
            } else {
              return h('span', {}, 'N/A')
            }
          }
        }
      ],
      parmas: {
        sn: '',
        companyId: '',
        searchText: ''
      },
      dialogVisible: false,
      orgData: [],
      row: [],
      props: {
        label: 'organizationName',
        children: 'children'
      },
      employeeData: [],
      treeId: '',
      pagination: {
        sizes: 10,
        curPage: 1,
        total: 0
      },
      isDialogPage: false,
      companyId: ''
    }
  },
  props: {
    devSn: {
      type: String,
      default: ''
    },
    contentHeight: {
      type: Number,
      default: 500
    }
  },
  watch: {
    devSn: {
      handler: function(val, oVal) {
        if (val) {
          this.parmas.sn = val
          try {
            this.parmas.companyId =
              this.companyId || sessionStorage.getItem('companyId') || ''
          } catch (e) {}
          this.loadDeviceEmployeList()
        }
      }
    }
  },
  mounted() {
    this.companyId = this.$route.query.companyId
    if (this.devSn) {
      this.parmas.sn = this.devSn
      try {
        this.parmas.companyId =
          this.companyId || sessionStorage.getItem('companyId') || ''
      } catch (e) {}
      this.loadDeviceEmployeList()
    }
  },
  methods: {
    // 人员进行设备绑定
    submitEmployeeBindDevice() {
      let selectEmploye = this.$refs.employeeTable.selection
      let employeeId = []
      let deviceSn = []
      selectEmploye.forEach(item => {
        employeeId.push(item.id)
      })
      let params = {
        companyId: this.companyId,
        deviceSn: deviceSn.concat(this.parmas.sn),
        employeeId: employeeId
      }
      setEmployeeBindDevices(params)
        .then(data => {
          if (data.code === '00000000') {
            this.loadDeviceEmployeList()
            this.$refs.employeeTable.clearSelection()
            this.dialogVisible = false
          } else {
            this.$message.error(data.message)
          }
        })
        .catch(e => {})
    },

    // dailog显示，查组织架构
    bindByDevice() {
      let params = {
        companyId: this.companyId
      }
      getOrgStructure(params)
        .then(data => {
          if (data.code === '00000000') {
            this.dialogVisible = true
            this.isDialogPage = true
            this.orgData = data.payload.results.organizationTree
            if (this.orgData && this.orgData.length > 0) {
              this.$nextTick(() => {
                this.treeId = this.orgData[0].id
                this.$refs.org.setCurrentKey(this.treeId)
                let params = {
                  pager: this.pagination,
                  params: {
                    companyId: this.orgData[0].companyId,
                    organizationId: this.orgData[0].id,
                    devSn: this.device.devSn
                  }
                }
                this.getEmployeeList(params)
              })
            }
          } else {
            this.$message.error(data.message)
          }
        })
        .catch(e => {})
    },

    // 获取未绑定的人员列表
    getEmployeeList(params) {
      getUnbindDeviceEmployeList(params)
        .then(data => {
          if (data.code === '00000000') {
            this.employeeData = data.payload.results
            this.pagination.sizes = data.payload.pageSize
            this.pagination.curPage = data.payload.curPage
            this.pagination.total = data.payload.totalRecords
          } else {
            this.$message.error(data.message)
          }
        })
        .catch(e => {})
    },

    // 根据organizationId查找员工列表
    handleCheckChange(row) {
      this.row = row
      let params = {
        pager: this.pagination,
        params: {
          organizationId: row.id,
          companyId: row.companyId
        }
      }
      this.getEmployeeList(params)
    },

    handleClose() {
      this.dialogVisible = false
      this.isDialogPage = false
    },

    // 设备解绑
    unbindDevice(row) {
      let employeeId = []
      let deviceSn = []

      this.$confirm(
        this.$t('deviceEmp.unbindDevice'),
        this.$t('common.warningNotice'),
        {
          confirmButtonText: this.$t('common.confirm'),
          cancelButtonText: this.$t('common.cancel'),
          type: 'warning'
        }
      )
        .then(() => {
          let params = {
            employeeId: employeeId.concat(row.id),
            companyId: row.companyId,
            deviceSn: deviceSn.concat(this.parmas.sn)
          }
          setEmployeeUnBindDevices(params)
            .then(data => {
              if (data.code === '00000000') {
                this.$message.success(this.$t('deviceEmp.unbindSuc'))
                this.loadDeviceEmployeList()
              } else {
                this.$message.error(data.message)
              }
            })
            .catch(e => {})
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('deviceEmp.unbindCan')
          })
        })
    },
    changePage(current) {
      if (this.isDialogPage) {
        this.pagination.curPage = current
        let params = {
          pager: this.pagination,
          params: {
            companyId: this.orgData[0].companyId || this.row.companyId,
            organizationId: this.orgData[0].id || this.row.id
          }
        }
        this.getEmployeeList(params)
      } else {
        this.pager.curPage = current
        this.loadDeviceEmployeList()
      }
    },
    changePageSize(pageSize) {
      if (this.isDialogPage) {
        this.pagination.sizes = pageSize
        let params = {
          pager: this.pagination,
          params: {
            companyId: this.orgData[0].companyId || this.row.companyId,
            organizationId: this.orgData[0].id || this.row.id
          }
        }
        this.getEmployeeList(params)
      } else {
        this.pager.pageSize = pageSize
        this.loadDeviceEmployeList()
      }
    },
    loadDeviceEmployeList() {
      // this.pager = {
      //   curPage: 1,
      //   pageSize: 10
      // }
      let params = {
        pager: this.pager,
        params: this.parmas
      }
      getDeviceEmployeList(params)
        .then(data => {
          if (data.code === '00000000') {
            // 已经绑定设备的人员列表
            this.tableData = data.payload.results
            this.pager.pageSize = data.payload.pageSize
            this.pager.curPage = data.payload.curPage
            this.pager.total = data.payload.totalRecords
          } else {
            this.$message.error(data.message)
          }
        })
        .catch(e => {})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/enterpriseAdmin/deviceManager/deviceCmp/deviceEmploye.vue